import { render, staticRenderFns } from "./MultiSelectPicker.vue?vue&type=template&id=bedf039a&scoped=true&"
import script from "./MultiSelectPicker.vue?vue&type=script&lang=js&"
export * from "./MultiSelectPicker.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectPicker.vue?vue&type=style&index=0&id=bedf039a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf039a",
  null
  
)

export default component.exports